import client from '../client';
import { exportFile } from '../requestDownloadFile';

export default {
  getCampaigns: data => {
    return client.get('publisher/placement/campaigns/list', { params: data }).then(res => res.data);
  },
  getCampaignsEarnings: data => {
    return client.get('publisher/placement/campaigns/earnings', { params: data }).then(res => res.data);
  },
  getCampaignsDetail: data => {
    return client.get(`publisher/placement/campaigns/${data.campaignId}/detail`, { params: data }).then(res => res.data);
  },
  acceptCampaign: data => {
    return client.post(`publisher/placement/campaigns/${data.campaignId}/accept`, { params: data }).then(res => res.data);
  },
  declineCampaign: data => {
    return client.post(`publisher/placement/campaigns/${data.campaignId}/decline`, { params: data }).then(res => res.data);
  },
  payCampaign: data => {
    return client.post(`publisher/placement/campaigns/${data.campaignId}/complete`,  data ).then(res => res.data);
  },
  generateLinks: data => {
    return client.post(`publisher/placement/campaigns/${data.campaignId}/generate-links`, data).then(res => res.data);
  },
  exportCampaigns: (fileName, data) => { 
    return exportFile(`publisher/placement/campaigns/${data.campaignId}/download-resources`, data, fileName)
    // return client.post('publisher/product/export',data).then(res=>console.log(res));
  },
}